var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useMemo } from "react";
import { useTabContext } from "./Tab.context";
var TabPanel = forwardRef(function (_a, ref) {
    var children = _a.children, idTab = _a.idTab, className = _a.className, style = _a.style, otherprops = __rest(_a, ["children", "idTab", "className", "style"]);
    var _b = useTabContext(), selected = _b.selected, idTabs = _b.idTabs;
    var classPanel = useMemo(function () {
        if (idTab === selected) {
            return "fr-tabs__panel--selected";
        }
        var positionOfSelected = idTabs === null || idTabs === void 0 ? void 0 : idTabs.findIndex(function (element) { return element === selected; });
        var positionOfThisTab = idTabs === null || idTabs === void 0 ? void 0 : idTabs.findIndex(function (element) { return element === idTab; });
        if (positionOfSelected === undefined || positionOfThisTab === undefined) {
            throw new Error("Le systeme d'onglet doit avoir des composants TabPanel");
        }
        if (positionOfSelected > positionOfThisTab) {
            return "fr-tabs__panel--direction-start";
        }
        else {
            return "fr-tabs__panel--direction-end";
        }
    }, [selected, idTabs, idTab]);
    return (React.createElement("div", __assign({}, otherprops, { ref: ref, id: "".concat(idTab, "-panel"), className: "fr-tabs__panel ".concat(classPanel, " ").concat(className || ""), role: "tabpanel", "aria-labelledby": idTab, tabIndex: 0, style: style }), children));
});
export default TabPanel;
